<template>
    <div id="app">
     <!-- 面包屑：名称与菜单配置同步 -->
    <AppBreadcrumb :items="[{ path: 'basicData' }, { path: 'strategy' }]" />
    <div class="topToip">
      <el-button type="text" @click="BaisData">{{$t('strategy.查看阀控策略白名单')}}</el-button>
      <!-- <el-button @click="chuanko">串口</el-button> -->
    </div>
    <!-- table表格 -->
    <div class="tab">
      <el-card>
    <el-table :data="tableData" size=mini highlight-current-row :header-cell-style = "{background:'#987AFF'}"  v-loading="loading" :height="isMobile ? 300 : 400">
    <el-table-column property="name" :label="$t('strategy.名称')" width="" />
    <el-table-column v-if="isMobile" property="automatic_closing_valve_for_arrears" :label="$t('strategy.欠费自动关阀')" width="" >
      <template slot-scope="{row: {automatic_closing_valve_for_arrears}}">
        <span v-if="automatic_closing_valve_for_arrears === true">{{$t('users.是')}}</span>
        <span v-else>{{$t('users.否')}}</span>
      </template>
    </el-table-column>
    <!-- <el-table-column v-if="isMobile" property="project_address" label="地址" width="" :show-overflow-tooltip="true" /> -->
    <el-table-column property="automatic_closing_valve_for_arrears" label="欠费自动关阀" width="" >
      <template slot-scope="{row: {automatic_closing_valve_for_arrears}}">
        <span v-if="automatic_closing_valve_for_arrears === true">是</span>
        <span v-else>否</span>
      </template>
    </el-table-column>
    <el-table-column v-if="!isMobile" property="alarm_close_valve_standard" :label="$t('strategy.报警关阀标准')" width="" />
    <el-table-column v-if="!isMobile" property="owe_close_valve_standard" label="欠费自动关阀标准" width="" />
    <el-table-column property="valve" :label="$t('strategy.操作')" :fixed="isMobile ? false : 'right'">
      <template slot-scope="scope">
        <template v-if="!isMobile">
          <el-button size="mini" @click="ficsati(scope.row)">{{$t('strategy.修改')}}</el-button>
        </template>
        <template v-else>
          <el-dropdown trigger="click" :hide-on-click="true" @command="handleMobileAction">
            <el-button size="mini" type="primary">
              {{$t('strategy.操作')}}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{ action: 'edit', row: scope.row }">{{$t('strategy.修改')}}</el-dropdown-item>
              <el-dropdown-item :command="{ action: 'detail', row: scope.row }">详情</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </template>
    </el-table-column>
  </el-table>
      </el-card>
  </div>
   <!-- 编辑的弹框 -->
   <div class="locationOpenvalve">
  <el-dialog :title="$t('strategy.账号编辑')" :visible.sync="diaes">
  <el-form>
    <el-form-item :label="$t('strategy.欠费自动关阀') + ':'" style="letter-spacing: 0px;">
              <el-select :placeholder="$t('strategy.请选择是否欠费')" v-model="ficsData.automatic_closing_valve_for_arrears">
                <el-option
                  v-for="item in zaisns"
                  :key="item.id"
                  :label="$t('users.' + item.name)"
                  :value="item.id">
                </el-option>
              </el-select>
    </el-form-item>
    <el-form-item :label="$t('strategy.报警关阀剩余量') + ':'" style="margin-left:10px">
      <el-input v-model.trim="ficsData.alarm_close_valve_standard" type="number" style="width: 100px;"></el-input>&nbsp;
      <span>{{$t('strategy.元')}}</span>
    </el-form-item>
    <el-form-item :label="$t('strategy.欠费自动关阀剩余量') + ':'" style="margin-left:10px">
      <el-input v-model.trim="ficsData.owe_close_valve_standard" type="number" style="width: 100px;"></el-input>&nbsp;
      <span>{{$t('strategy.元')}}</span>
    </el-form-item>
  </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click=Biaos> <i class="el-icon-document"/>{{('保 存')}}</el-button>
  </span>
</el-dialog>
</div>
<!-- 查看白名单 -->
<div class="locationOpenvalve">
<el-dialog :title="$t('strategy.阀控策略白名单')" :visible.sync="dialogTableVisible">
  <div class="Sousui">
    <el-input v-model="Cxions.meter_id" :placeholder="$t('strategy.请输入水表编号')"></el-input>
    <el-button @click="SoiCanBtn">{{$t('strategy.查询')}}</el-button>
    <el-button @click="SoiXanBtn">{{$t('strategy.刷新')}}</el-button>
  </div>
  <el-table :data="gridData" highlight-current-row :header-cell-style="{'text-align':'center'}"  :cell-style="{'text-align':'center'}" height='300'>
    <el-table-column property="meter_id" :label="$t('strategy.水表编号')"></el-table-column>
    <el-table-column
      fixed="right"
      :label="$t('strategy.操作')">
      <template slot-scope="scope">
        <el-button 
          @click="deleteRow(scope.row)"
          type="text"
          size="small">
          {{$t('strategy.移除')}}
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</el-dialog>
</div>
<div class="locationOpenvalve">
  <el-dialog title="详情" :visible.sync="mobileDetailVisible">
    <div class="mobile-detail-content">
      <div v-for="item in mobileDetailItems" :key="item.key">
        <span>{{ item.label }}：</span>{{ item.value }}
      </div>
    </div>
  </el-dialog>
</div>
    </div>
</template>
<script>
export default {
  inject: ['reload'],
  data () {
    return {
      // 修改保存
      ficsData: {
        token: null,
        community_id: null,
        automatic_closing_valve_for_arrears: null,
        owe_close_valve_standard: null,
        alarm_close_valve_standard: null
      },
      diaes: false,
      // tab
      tableData: [{
        name: null,
        automatic_closing_valve_for_arrears: null,
        mch_id: null,
        wechat_appid: null
      }],
      loading: true,
      // 登录返回的项目id
      famlis: {
        token: null
      },
      // 费用下拉框
      zaisns: [{
        id: true,
        name: 'yes'
      },
      {
        id: false,
        name: 'no'
      }],
      // 白名单
      gridData: [],
      dialogTableVisible: false,
      // 移除白名单
      Yichu: {
        token: null,
        meter_id: null
      },
      // 查询白名单
      Cxions: {
        token: null,
        meter_id: null
      },
      isMobile: false,
      mobileDetailVisible: false,
      mobileDetailRow: {}
    }
  },
  computed: {
    mobileDetailItems () {
      const row = this.mobileDetailRow || {}
      const fieldMap = [
        { key: 'name', label: this.$t('strategy.名称') },
        { key: 'automatic_closing_valve_for_arrears', label: this.$t('strategy.欠费自动关阀') },
        { key: 'alarm_close_valve_standard', label: this.$t('strategy.报警关阀标准') },
        { key: 'owe_close_valve_standard', label: this.$t('strategy.欠费自动关阀标准') }
      ]
      return fieldMap.map(item => ({
        key: item.key,
        label: item.label,
        value: row[item.key] === null || row[item.key] === undefined || row[item.key] === '' ? '-' : row[item.key]
      }))
    }
  },
  created () {
    this.updateIsMobile()
    this.famlis.token = this.$store.state.print.goodsForeNo.token
    this.tabData()
  },
  mounted () {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateIsMobile)
  },
  methods: {
    updateIsMobile () {
      this.isMobile = typeof window !== 'undefined' && window.innerWidth <= 768
    },
    showDetail (row) {
      this.mobileDetailRow = {
        ...row,
        automatic_closing_valve_for_arrears: row && row.automatic_closing_valve_for_arrears === true ? this.$t('users.是') : this.$t('users.否')
      }
      this.mobileDetailVisible = true
    },
    handleMobileAction (command) {
      if (!command || !command.action) return
      if (command.action === 'edit') {
        this.ficsati(command.row)
        return
      }
      if (command.action === 'detail') {
        this.showDetail(command.row)
      }
    },
    async chuanko () {
      // 提示用户选择一个串口。
      const port = await navigator.serial.requestPort()
      console.log(port)
      // 等待串口打开
      await port.open({ baudRate: 57600 })
      // 异步监听串口数据
      while (port.readable) {
        const reader = port.readable.getReader()
        console.log(reader, 'reader')
        try {
          while (true) {
            const { value, done } = await reader.read()
            console.log(value, done, 'valiedone')
            if (done) {
              // 接收完毕，串口解锁
              reader.releaseLock()
              break
            }
            if (value) {
              console.log(value)
            }
          }
        } catch (error) {
          // 错误处理
        }
      }
    },
    // table数据
    tabData () {
      this.$api.userProfile.communities(this.famlis).then((res) => {
        if (res.data.status === 'success') {
          console.log(res.data.data, '全局配置tab')
          this.tableData = res.data.data
          this.loading = false
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        }
        if (res.data.message === this.$t('common.用户在别处登录')) {
          this.$router.push('/', this.fasinull)
        }
      })
    },
    // 编辑
    ficsati (row) {
      console.log(row, '修改')
      this.ficsData.automatic_closing_valve_for_arrears = row.automatic_closing_valve_for_arrears
      this.ficsData.owe_close_valve_standard = row.owe_close_valve_standard
      this.ficsData.alarm_close_valve_standard = row.alarm_close_valve_standard
      console.log(this.ficsData)
      this.ficsData.community_id = row.id
      this.diaes = true
    },
    // 修改保存
    Biaos () {
      this.ficsData.token = this.$store.state.print.goodsForeNo.token
      this.$api.Location.postcommunities(this.ficsData).then((res) => {
        if (res.data.status === 'success') {
          console.log(res, '修改成功值')
          this.diaes = false
          this.reload()
          this.$message({
            message: res.data.message,
            type: 'success'
          })
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        } else if (res.data.message === this.$t('common.用户在别处登录')) {
          this.$router.push('/', this.fasinull)
        }
      })
    },
    // 白名单获取
    BaisData () {
      this.dialogTableVisible = true
      this.$api.waterMeter.closeValveServerWhiteListGet(this.famlis).then((res) => {
        if (res.data.status === 'success') {
          console.log(res, '获取白名单数据')
          this.gridData = res.data.white_list
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        } else if (res.data.message === this.$t('common.用户在别处登录')) {
          this.$router.push('/', this.fasinull)
        }
      })
    },
    // 查询白名单
    SoiCanBtn () {
      this.Cxions.token = this.$store.state.print.goodsForeNo.token
      this.$api.waterMeter.closeValveServerWhiteListGet(this.Cxions).then((res) => {
        if (res.data.status === 'success') {
          console.log(res, '获取白名单数据')
          this.gridData = res.data.white_list
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        } else if (res.data.message === this.$t('common.用户在别处登录')) {
          this.$router.push('/', this.fasinull)
        }
      })
    },
    // 刷新白名单
    SoiXanBtn () {
      this.BaisData()
      this.Cxions.meter_id = null
    }, 
    // 白名单移除
    deleteRow (row) {
      console.log(row, '移除白名单')
      this.Yichu.token = this.$store.state.print.goodsForeNo.token 
      this.Yichu.meter_id = row.meter_id
      this.$api.waterMeter.closeValveServerWhiteListDel(this.Yichu).then((res) => {
        if (res.data.status === 'success') {
          console.log(res, '移除白名单')
          this.BaisData()
          this.$message({
            message: res.data.message,
            type: 'success'
          })
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        } else if (res.data.message === this.$t('common.用户在别处登录')) {
          this.$router.push('/', this.fasinull)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
// 面包屑
.Gnv {
  width: 100%;
  height: 32px; 
  display: flex;
  align-items: center;
  background-color: #ecf0f1;
  font-size: 19px;
  letter-spacing: 1px;
  //   font-family: myFont;
  .el-breadcrumb {
    display: flex;
    align-items: center;
    margin-left: 20px;
    .yai{
      width: 5px;
      height: 17px;
      background-color: #987AFF;
      margin-right: 18px;
    }
    ::v-deep .el-breadcrumb__item{
      margin-left: 0px;  
      .el-breadcrumb__inner.is-link{
        font-weight: 100;
        color: #656d92;
  }
    }
  }
}
// 按钮区域
.topToip{
  margin: 20px 20px;
  .el-button{
    background-color: #744dfe;
    color: #fff;
    padding: 10px 10px;
  }
}
// <!-- table表格 -->
    .tab{
        padding: 20px 30px 0px 20px;
        .el-card{
          border-radius: 10px;
          ::v-deep .el-card__body{
            padding: 0px;
          }
          ::v-deep .el-table__header-wrapper{
            background-color: #987AFF;
              width: 100%;
          }
          ::v-deep .el-table tr{
            background-color: #F9F9F9;
          }
          ::v-deep .el-table thead{ 
            color: #fff;
            font-weight: 300;
          }
         ::v-deep .cell{
           font-family:myFont; 
          }
        }
        ::v-deep .cell{
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          text-align: center;
        }
       ::v-deep .el-table__header{
         width: 0;
          width: 100%;
        }
        .el-button{
          border: 1px solid #744dfe;
          background-color: #744dfe;
          color: #FFF;
        }
    }
    // 修改弹框
    .el-dialog{
      .el-form{
        display: flex;
        flex-wrap: wrap;
        .el-form-item{
          display: flex;
          .el-input{
            width: 200px;
          }
          .el-select{
            width: 180px;
          }
        }
      }
      .dialog-footer{
        .el-button{
          background-color: #fff;
          border: 1px solid #744dfe;
          color: #575757;
          border-radius: 10px;
          font-size: 17px;
          span{
            i{
              font-size: 20px;
              margin-right: 10px;
            }
          }
        }
      }
    }
    .Sousui{
      display: flex;
    }
    .locationOpenvalve .el-dialog__wrapper{
  ::v-deep .el-dialog{
    width: 30%;
  }
}
        // 移动端
        @media (max-width: 768px) {
      .Gnv{
        display: none;
      }
      .topToip{
        margin: 10px 10px;
      }
      .tab{
        padding: 10px 10px;
        ::v-deep .el-table__body-wrapper{
          overflow-x: hidden !important;
        }
        ::v-deep .el-table__header-wrapper{
          overflow-x: hidden !important;
        }
      }
      .locationOpenvalve .el-dialog__wrapper{
  ::v-deep .el-dialog{
    width: 94%;
  }
}
      .mobile-detail-content{
        max-height: 60vh;
        overflow-y: auto;
        div{
          line-height: 22px;
          margin-bottom: 6px;
          word-break: break-all;
          span{
            color: #606266;
            font-weight: 400;
          }
        }
      }
    }
</style>
